import * as Sentry from '@sentry/react'

/**
 * Errores del portal a Sentry (Fase 7, paso 8). Sólo en los deploys de
 * Netlify, con el ambiente separado ("produccion", "revision", "develop").
 * Sólo Error Monitoring: sin Session Replay, sin trazas y sin datos
 * personales (ni IP, ni mail, ni nombre).
 */
const DSN =
  'https://7eda25847a3e99bfa8cbd316dc466517@o4512142446690304.ingest.us.sentry.io/4512142456061952'

export function iniciarSentry() {
  const ambiente = import.meta.env.VITE_AMBIENTE
  if (!ambiente || ambiente === 'local') return
  Sentry.init({
    dsn: DSN,
    environment: ambiente,
    release: import.meta.env.VITE_COMMIT,
    tracesSampleRate: 0,
    // Ruido del navegador que no es del portal.
    ignoreErrors: ['ResizeObserver loop', 'Non-Error promise rejection captured'],
  })
}

const reportar = Sentry.reactErrorHandler()

/** Para los manejadores de errores de React 19 en `createRoot`. */
export function alErrorDeReact(
  error: unknown,
  info: { componentStack?: string | null | undefined },
) {
  reportar(error, info.componentStack ? { componentStack: info.componentStack } : {})
}
